import {
  NotificationCountQueryParams,
  NotificationListQueryParams,
} from '@diamond/shared/types';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getNotification, getNotificationCount } from '../queries';
import { useAuthStore, useShipToStore } from '../stores';

export const NOTIFICATION_QUERY_KEY = 'notification';

export function useNotification(
  params: Readonly<Omit<NotificationListQueryParams, 'warehouse'>>
) {
  const queryClient = useQueryClient();
  const accessToken = useAuthStore((state) => state.access_token);
  const selectedShipToId = useShipToStore((state) => state.selectedShipToId);

  const qs: NotificationListQueryParams = {
    ...params,
    warehouse: selectedShipToId,
  };

  // Prefetch the next page
  useEffect(() => {
    if (params && typeof params['page'] === 'number') {
      const nextParams = { ...qs, page: params['page'] + 1 };
      queryClient.prefetchQuery({
        queryKey: [NOTIFICATION_QUERY_KEY, 'list', nextParams],
        queryFn: () => getNotification(accessToken, nextParams),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params['page']]);

  const query = useQuery({
    queryKey: [NOTIFICATION_QUERY_KEY, 'list', qs],
    queryFn: () => getNotification(accessToken, qs),
    enabled: !!selectedShipToId,
  });

  return query;
}

export function useNotificationCount() {
  const accessToken = useAuthStore((state) => state.access_token);
  const selectedShipToId = useShipToStore((state) => state.selectedShipToId);

  const qs: NotificationCountQueryParams = {
    warehouse: selectedShipToId,
  };

  const query = useQuery({
    queryKey: [NOTIFICATION_QUERY_KEY, 'count', qs],
    queryFn: () => getNotificationCount(accessToken, qs),
    enabled: !!selectedShipToId,
  });

  return query;
}
